import { useEffect } from "react";
import Video from './Video';
import Arrow from '../assets/svg/arrow.svg'
import '../styles/modal.scss';

const Modal = ({
    enabled, 
    modalData, 
    toggleModal,
    prevModalContext,
    nextModalContext,
  }) => {

  useEffect(()=> {
    if (enabled){
    document.addEventListener('keydown', (e) => {
      if (e.key === "Escape") {
        videoStopper()
        toggleModal()
      }
    })
  } else {
    document.removeEventListener('keydown', () => {
      videoStopper()
      toggleModal()
    })
  }
  return () => {
    document.removeEventListener('keydown', () => {
      videoStopper()
      toggleModal()
    })
  }
  }, [enabled])

  const videoStopper = () => {
    document.querySelectorAll('iframe').forEach(v => { v.src = v.src });
    document.querySelectorAll('video').forEach(v => { v.pause() });
  }

  const close = () => {
    videoStopper()
    document.onclick = (e) => {
      if (e.target.id.includes("modal")) {
        toggleModal()
      }
    }
  }

  const modalText = () => {
    if (modalData.type == 'video+nav') { 
      return(
        <>
        <h3 className="h3 modal__title">{modalData.id}. {modalData.title}</h3>
        <p className="para modal__description">{modalData.description}</p>
        </>
      )
    } else {
      return (
        <>
          <h3 className="h3 modal__title">{modalData.title}</h3>
          <p className="para modal__description">{modalData.description}</p>
          <button className="modal__nav--back" onClick={()=>{toggleModal();videoStopper();}} >Back to map</button>
        </>
      )
    }
  }


  const modalNav = () => {

    return(
      <>
      <div className="modal__nav">
        <button className="modal__nav--prev" onClick={prevModalContext}>
          <img src={Arrow} alt="arrow" />
          Prev Stage 
        </button>
        <button className="modal__nav--back" onClick={()=>{toggleModal();videoStopper();}} >Back to map</button>
        <button className="modal__nav--next"  onClick={nextModalContext} >
          Next Stage 
          <img src={Arrow} alt="arrow" />
        </button>
      </div>
      </>
    )
  }

  return (
    <>
      <div id="modal" className={ enabled ? `modal modal--active type-${modalData.type}` : `modal type-${modalData.type}` } onClick={()=>{close()}}>
        <div className="modal__content">
         <Video
           videoSrc={modalData.url}
         />
          { modalText() }
          { modalData.type == 'video+nav' ? modalNav() : null }
        </div>
      </div>
    </>
  );
}

export default Modal
